import bridge from '@vkontakte/vk-bridge';
import { createEffect } from 'effector';
import { ISetImageStatusArgs } from '../../model/types';

export const setImageStatusFx = createEffect<ISetImageStatusArgs, number, Error>(async (
  { $userAccessToken, imageStatusId }
) => {
  if (!$userAccessToken) {
    throw new Error('Отсутствует access_token');
  }

  if (!imageStatusId) {
    throw new Error('Отсутствует imageStatusId');
  }

  try {
    const { response } = await bridge.send(
      'VKWebAppCallAPIMethod',
      {
        method: 'status.setImage',
        params: {
          v: '5.131',
          access_token: $userAccessToken,
          status_id: imageStatusId
        }
      }
    );

    if (!response) {
      throw new Error('Ошибка получения списка статусов');
    }

    // @ts-ignore
    bridge.send('VKWebAppSendCustomEvent', {
      type: 'emoji_status_complete_click',
      json: JSON.stringify({
        emoji: imageStatusId
      })
    });

    return imageStatusId;
  } catch (error) {
    throw new Error(String(error));
  }
});
